/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import IconButton from '@mui/material/IconButton';
import Icon from "@mui/material/Icon";
import ConfirmDialog from "components/ConfirmDialog";
import TableSkeleton from "components/TableSkeleton";
import CustomAlert from "components/CustomAlert";
import CustomInput from "components/MDInputField/CustomInput";

// Data
import { useEffect, useState, useMemo } from "react";
import { RoleAPI } from "api/RoleAPI";
import { ProarnesAPI } from "api/ProarnesAPI";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import permissions from "permissions";


function ListArnes() {
  const [controller, dispatch] = useMaterialUIController();
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state;
  const [roles, setRoles] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [id, setId] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const { user, loading, admin } = controller;

  const [archivo, setArchivo] = useState(null);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const handleFileUpload = (file) => {
    setArchivo(file); 
    console.log("Archivo seleccionado:", file);
  };

  const handleFile = (buttonId) => {
    if (!archivo) {
      handleAlert(`Por favor, cargue los archivos .ini correspondientes a la base de datos ProArnes para continuar.`, "error");
      return;
    }
    
    const fileNames = {
      1: "RmCaDat.ini",
      2: "RmCoMC.ini",
      3: "RmCoDat.ini",
      4: "RmTerDat.ini"
    };
    
    if (archivo.name === fileNames[buttonId]) {
      console.log(`Archivo válido: ${archivo.name} (Botón ${buttonId})`); 
      const formData = new FormData();
      formData.append("file", archivo);
      try {
        switch (buttonId) {
          case 1:
            ProarnesAPI.cableado(formData)
            .then((response) => {
            console.log("Respuesta del servidor:", response);

            if (response.status) {
              console.log("Archivo enviado con éxito a Cableado");
              handleAlert(response.message, "success");
            } else {
              console.error("Error en la respuesta:", response.message);
              handleAlert(response.message, "error");
            }
          })
          .catch((error) => {
            console.error("Error en la petición:", error);
            if (error.response) {
              handleAlert(error.response.data.message, "error");
            }
            });
            // await axios.post("/api/upload/cableado", { file: archivo });
            //console.log("Archivo enviado a Cableado");
            break;
          case 2:
              ProarnesAPI.coberturas(formData) 
            .then((response) => {
              console.log("Respuesta del servidor:", response);

              if (response.status) {
                console.log("Archivo enviado con éxito a Coberturas");
                handleAlert(response.message, "success");
        
                // Procesar los datos para la tabla
                if (response.content) {
                  const lines = response.content.split("\n").slice(2); 
                  const formattedData = lines.map((line) => {
                    const [codigo, detalles] = line.split("=");
                    if (!detalles) return null; 
        
                    const parts = detalles.split(",");
                    if (parts.length === 4) {
                      return {
                        codigo: codigo.trim(),
                        tipo: parts[0].trim(),
                        estado: parts[1].trim(),
                        color: parts[2].trim(),
                        medida: parts[3].trim(),
                      };
                    }
                    return null;
                  }).filter(Boolean); 
        
                  setTableData({
                    columns: [
                      { Header: "Código", accessor: "codigo" },
                      { Header: "Tipo", accessor: "tipo" },
                      { Header: "Estado", accessor: "estado" },
                      { Header: "Color", accessor: "color" },
                      { Header: "Medida", accessor: "medida" },
                    ],
                    rows: formattedData,
                  });
                }

              }else {
                  console.error("Error en la respuesta:", response.message);
                  handleAlert(response.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error en la petición:", error);
                if (error.response) {
                  handleAlert(error.response.data.message, "error");
                }
              });
            break;
            // await axios.post("/api/upload/coberturas", { file: archivo });
            //console.log("Archivo enviado a Coberturas");
          case 3:
            ProarnesAPI.conectores(formData) 
            .then((response) => {
              console.log("Respuesta del servidor:", response);

                if (response.status) {
                  console.log("Archivo enviado con éxito a Coberturas");
                  handleAlert(response.message, "success");
                } else {
                  console.error("Error en la respuesta:", response.message);
                  handleAlert(response.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error en la petición:", error);
                if (error.response) {
                  handleAlert(error.response.data.message, "error");
                }
              });
            break;
          case 4:
            ProarnesAPI.terminales(formData) 
            .then((response) => {
              console.log("Respuesta del servidor:", response);

                if (response.status) {
                  console.log("Archivo enviado con éxito a Terminales");
                  handleAlert(response.message, "success");
                } else {
                  console.error("Error en la respuesta:", response.message);
                  handleAlert(response.message, "error");
                }
              })
              .catch((error) => {
                console.error("Error en la petición:", error);
                if (error.response) {
                  handleAlert(error.response.data.message, "error");
                }
              });
            break;

          default:
            console.log("Botón no reconocido");
        }
      } catch (error) {
        console.error("Error al enviar el archivo:", error);
      }
    } else {
      // console.log("El nombre del archivo no corresponde");
      handleAlert(`El nombre de archivo ${archivo.name} no concuerda con la acción`, "error");
    }
  };

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }


  const handleAlertClose = () => setAlert(false);

  const handleClick = () => {
    navigate('create');
  }

  const handleDelete = (id) => {
    setId(id)
    setIsDeleting(true);
  }

  const handleCancelDelete = () => {
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    return deleteRole(id)
  };

  // const renderTable = useMemo(() => {
  //   let rows = [];
  //   const columns = [
  //     { Header: "rol", accessor: "role", width: "45%", align: "left" },
  //     { Header: "acción", accessor: "action", align: "center" },
  //   ];

  //   roles.map((element) => {
  //     rows = [...rows,
  //     {
  //       role: element.name,
  //       action: (
  //         <MDBox>
  //           {(user?.permissions?.includes(permissions.roles[2]) || user?.role === admin) && (
  //             <IconButton component={Link} aria-label="edit" value={element.id} to={element.id + '/edit'}>
  //               <Icon fontSize="small">edit</Icon>
  //             </IconButton>
  //           )}
  //           {(user.permissions?.includes(permissions.roles[3]) || user?.role === admin) && (
  //             <IconButton aria-label="delete" value={element.id} onClick={() => handleDelete(element.id)}>
  //               <Icon fontSize="small">delete</Icon>
  //             </IconButton>
  //           )}
  //         </MDBox>
  //       ),
  //     }
  //     ]
  //   });


  //   return <DataTable
  //     table={{ columns, rows }}
  //     isSorted={true}
  //     entriesPerPage={true}
  //     showTotalEntries={true}
  //     noEndBorder
  //     canSearch={true}
  //   />
  // }, [roles])

  const deleteRole = (id) => {
    return RoleAPI.delete(id)
      .then(response => {
        const updatedRoles = roles.filter((role) => role.id !== response.role);
        setRoles(updatedRoles);
        handleAlert(response.message, 'success');
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        handleCancelDelete();
      });
  }

  const getRoles = (signal) => {
    return RoleAPI.index(signal)
      .then(response => {
        setRoles(response.roles)
      }).catch(error => {
        if (error.response)
          handleAlert(error.response.data.message, 'error')
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);

  // useEffect(() => {
  //   window.history.replaceState({}, document.title)
  //   const abortController = new AbortController();
  //   const signal = abortController.signal

  //   setLoading(dispatch, true)
  //   getRoles(signal)

  //   return () => {
  //     abortController.abort();
  //   };
  // }, []);



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            
            {/* <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions?.includes(permissions.roles[1]) || user?.role === admin) && (
                <MDButton variant="gradient" color="info" onClick={handleClick}> Crear Rol</MDButton>
              )}
            </MDBox> */}
             

            <MDBox mb={4} px={2}>
              <CustomAlert severity="secondary" message="en este sitio se puede cargar los archivos .ini correspondientes a la base de datos proarnes" open="true" onClose={handleAlertClose}></CustomAlert>
            </MDBox>

            <Card>

            
              <MDBox pt={5} mb={5} display="flex" justifyContent="space-around">
                <MDButton variant="gradient" color="info" onClick={() => handleFile(1)}>Importar Cableado</MDButton>
                <MDButton variant="gradient" color="info" onClick={() => handleFile(2)}>Importar Coberturas</MDButton>
                <MDButton variant="gradient" color="info" onClick={() => handleFile(3)}>Importar Conectores</MDButton>
                <MDButton variant="gradient" color="info" onClick={() => handleFile(4)}>Importar Terminales</MDButton>
              </MDBox>

              <MDBox mt={5} mb={5}  display="flex" justifyContent="center">
              <MDBox width="50%">
                <CustomInput accept=".pdf,.jpg,.png,.ini" onFileSelect={handleFileUpload} />
              </MDBox>
            </MDBox>

              {archivo && (
                <MDBox mt={2} textAlign="center">
                  <MDTypography variant="body1">Archivo seleccionado: {archivo.name}</MDTypography>
                </MDBox>
              )}

            </Card>

            {isDeleting && (<ConfirmDialog onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} ></ConfirmDialog>)}
          </Grid>
        </Grid>

          {/* tabla para visualizar lo cargado de la respuseta del servidor */}
          <Grid container justifyContent="center" mt={4} pb={3}>
            <MDBox sx={{ width: '100%' }}>
              {tableData.columns.length > 0 && (
                <Card sx={{ marginTop: '20px' }}>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Datos de la Importación
                    </MDTypography>
                  </MDBox>
                  <MDBox pt={3}>
                    <DataTable
                      table={tableData}
                      isSorted={true}
                      entriesPerPage={true}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </Card>
              )}
            </MDBox>
          </Grid>

          {/* tabla para visualizar lo cargado */}

      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ListArnes;